import { isNumber } from "@ng-bootstrap/ng-bootstrap/util/util";
import { ModelInvoice } from "./invoices";

export interface ResponseConvalida{
    messages: {type: string, text: string}[]
}

export class ConvalidaFattura{

    constructor(private fattura: ModelInvoice){}


    public addUserInvoice():ResponseConvalida{

        let response : ResponseConvalida = {messages: []};
        
        /*if(this.fattura.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.IdFiscaleIVA.IdPaese.length!=2){
            response.messages.push({type:"error", text: "ATTENZIONE, NON HAI SPECIFICATO LA NAZIONALITA' DEL CESSIONARIO/COMMITTENTE"});
            return response;
        }*/
        if(this.fattura.FatturaElettronicaHeader.DatiTrasmissione.CodiceDestinatario=='XXXXXXX' && this.fattura.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.IdFiscaleIVA.IdPaese=='IT'){
            response.messages.push({type:"error", text: "ATTENZIONE, IL CODICE DESTINATARIO INSERITO NON E' VALIDO PER LA NAZIONALITA' DEL CESSIONARIO/COMMITTENTE"});
            return response;
        }

        if(!this.controlloPartitaIVA()){
            response.messages.push({type:"error", text: "ATTENZIONE, LA PARTITA IVA DEL CESSIONARIO NON PUO' ESSERE MINORE DI 11 CARATTERI, SE ITALIANA"});
            response.messages.push({type:"warning", text: "Impossibile procedere all'invio"});
            return response;
        }

        /********************************************************************************/
        var helper:string|null;

        /*** Cedente prestatore ****/
        if(!this.controlloAnagrafica(this.fattura.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.Anagrafica)){
            response.messages.push({type:"error", text: "ATTENZIONE, INSERISCI LA DENOMINAZIONE O NOME E COGNOME DEL CEDENTE/PRESTATORE"});
        }
        if(!this.controlloFiscalCode(this.fattura.FatturaElettronicaHeader.CedentePrestatore)){
            response.messages.push({type:"error", text: "ATTENZIONE, IL CODICE FISCALE DEL CEDENTE/PRESTATORE E' ERRATO"});
        }
        if((helper=this.controlloSede(this.fattura.FatturaElettronicaHeader.CedentePrestatore.Sede,"CEDENTE/PRESTATORE")) != null ){
            response.messages.push({type:"error", text: helper});
        }
        /*if((helper=this.controlloStabileOrganizzazione(this.fattura.FatturaElettronicaHeader.CedentePrestatore.StabileOrganizzazione,"CEDENTE/PRESTATORE")) !=null){
            response.messages.push({type:"error", text: helper});
        }*/

        /***********cessionario committente******/
        if(!this.controlloAnagrafica(this.fattura.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.Anagrafica)){
            response.messages.push({type:"error", text: "ATTENZIONE, INSERISCI LA DENOMINAZIONE O NOME E COGNOME DEL CESSIONARIO/COMMITTENTE"});
            return response;
        }
        if(!this.controlloFiscalCode(this.fattura.FatturaElettronicaHeader.CessionarioCommittente)){
            response.messages.push({type:"error", text: "ATTENZIONE, IL CODICE FISCALE DEL CESSIONARIO E' ERRATO"});
            return response;
        }
        if((helper=this.controlloSede(this.fattura.FatturaElettronicaHeader.CessionarioCommittente.Sede,"CESSIONARIO/COMMITTENTE")) != null ){
            response.messages.push({type:"error", text: helper});
            return response;
        }
        /*if((helper=this.controlloStabileOrganizzazione(this.fattura.FatturaElettronicaHeader.CessionarioCommittente.StabileOrganizzazione,"CESSIONARIO/COMMITTENTE")) !=null){
            response.messages.push({type:"error", text: helper});
            return response;
        }*/
        /***********rappresentente fiscale*******/
        if((helper=this.controlloPartitaIvaOcodiceFiscaleRappFiscaleOSoggettoEmittente(this.fattura.FatturaElettronicaHeader.RappresentanteFiscale,"RAPPRESENTANTE FISCALE")) != null){
            response.messages.push({type:"error", text: helper});
            return response;
        }

        /*** Terzo Intermediario o Soggetto Emittente ****/
        if((helper=this.controlloPartitaIvaOcodiceFiscaleRappFiscaleOSoggettoEmittente(this.fattura.FatturaElettronicaHeader.TerzoIntermediarioOSoggettoEmittente,"TERZO INTERMEDIARIO O SOGGETTO EMITTENTE")) != null){
            response.messages.push({type:"error", text: helper});
            return response;
        }

        /************sezione dati documento *****************/
        
        if(this.fattura.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.TipoDocumento == ''){
                    response.messages.push({type:"error", text: "SPECIFICA IL TIPO DI DOCUMENTO"});
                    return response;
        }else{
                let TipoDocumento=this.fattura.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.TipoDocumento;
                if( TipoDocumento=="TD17" || TipoDocumento=="TD18" || TipoDocumento=="TD19"){
                    if(this.fattura.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.IdFiscaleIVA.IdPaese == "IT"){
                        response.messages.push({type:"error", text: "ATTENZIONE, IL TIPO DOCUMENTO NON PUO' ESSERE TD17/TD18/TD19.VERIFICA LA NAZIONE DEL CEDENTE/PRESTATORE"});
                        return response;
                    }
                }
        }
        if(this.fattura.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.Numero == ''){
            response.messages.push({type:"error", text: "SPECIFICA IL NUMERO DEL DOCUMENTO"});
            return response;
        }
        if(this.fattura.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.Data == ''){
            response.messages.push({type:"error", text: "SPECIFICA LA DATA DEL DOCUMENTO"});
            return response;
        }
        if((this.fattura.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.ImportoTotaleDocumento == '') 
                || (Number.isNaN(parseFloat(this.fattura.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.ImportoTotaleDocumento)))){
            response.messages.push({type:"error", text: "ATTENZIONE, L' IMPORTO TOTALE DEL DOCUMENTO NON E' VALIDO."});
            return response;
        }  

        if(this.fattura.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.Causale?.filter(l => l == "").length > 0){
            response.messages.push({type:"error", text: "ATTENZIONE, LA VOCE CAUSALE DEI DATI DOCUMENTO CONTIENE UNA O PIU' RIGHE VUOTE. COMPILALE O ELIMINALE."});
            return response;
        }
        /***************************************************/

        if(!this.controllo00415()){
            response.messages.push({type:"error", text: "ATTENZIONE, ERRORE 00411 O 00415 NELLA COMPILAZIONE DELLA FATTURA!"});
            response.messages.push({type:"warning", text: "Dati Ritenuta non presente a fronte del blocco Ritenuta uguale a SI nel Dettaglio Linee o in Dati Cassa Previdenziale"});
            response.messages.push({type:"warning", text: "Impossibile procedere all'invio"});
            return response;
        }

        if(!this.controllo00471()){
            response.messages.push({type:"error", text: "ATTENZIONE, ERRORE 00471 NELLA COMPILAZIONE DELLA FATTURA!"});
            response.messages.push({type:"warning", text: "I valori TD16, TD17, TD18, TD19 e TD20 del tipo documento non ammettono l'indicazione in fattura dello stesso soggetto sia come cedente che come cessionario"});
            response.messages.push({type:"warning", text: "Impossibile procedere all'invio"});
            return response;
        }

        if(!this.controllo00472()){
            response.messages.push({type:"error", text: "ATTENZIONE, ERRORE 00472 NELLA COMPILAZIONE DELLA FATTURA!"});
            response.messages.push({type:"warning", text: "Il tipo documento ‘autofattura per splafonamento’ non ammette l'indicazione in fattura di un cedente diverso dal cessionario"});
            response.messages.push({type:"warning", text: "Impossibile procedere all'invio"});
            return response;
        }

        if(!this.controllo00473()){
            response.messages.push({type:"error", text: "ATTENZIONE, ERRORE 00473 NELLA COMPILAZIONE DELLA FATTURA!"});
            response.messages.push({type:"warning", text: "I valori TD17, TD18 e TD19 del tipo documento non ammettono l'indicazione in fattura di un cedente italiano"});
            response.messages.push({type:"warning", text: "Impossibile procedere all'invio"});
            return response;
        }

        if(!this.controllo00474()){
            response.messages.push({type:"error", text: "ATTENZIONE, ERRORE 00474 NELLA COMPILAZIONE DELLA FATTURA!"});
            response.messages.push({type:"warning", text: "Nel caso di TD21, autofattura per splafonamento, come tipo documento in nessuna linea deve essere possibile inserire aliquota IVA uguale a zero"});
            response.messages.push({type:"warning", text: "Impossibile procedere all'invio"});
            return response;
        }

        if(!this.controlloDocumentiCorrelati()){
            response.messages.push({type:"warning", text: "Attenzione, nei documenti correlati è obbligatorio inserire il campo idDocumento se viene compilato il campo CIG"});
            response.messages.push({type:"warning", text: "Impossibile procedere all'invio"});
            return response;
        }
        /******************DATI PAGAMENTO*********************************/
        for(var i=0; i< this.fattura.FatturaElettronicaBody.DatiPagamento.length;i++){
            let ImportoPagamento=this.fattura.FatturaElettronicaBody.DatiPagamento[i].DettaglioPagamento.ImportoPagamento;
            if(Number.isNaN(parseFloat(ImportoPagamento)) || ImportoPagamento=='')
                    response.messages.push({type:"error", text: "ATTENZIONE, L'IMPORTO DEL PAGAMENTO DELLA LINEA N° "+ (i+1)+" NON E' CORRETTO"});
        }
        /****************************************************************/

        /* sezione DOCUMENTI CORRELATI*/
        let doc_correlati=this.fattura.FatturaElettronicaBody.DatiGenerali;
        doc_correlati.DatiOrdineAcquisto.forEach((riga,i)=>{
                if((riga.CodiceCIG!="" || riga.CodiceCUP!="") && riga.IdDocumento=="")
                    response.messages.push({type:"error", text: "ATTENZIONE, NON HAI SPECIFICATO L'ID Documento IN DOCUMENTI CORRELATI \
                                            NELLA VOCE 'Dati Ordine Acquisto' alla linea N° "+ (i+1)+""});
                                    return response;
                        

        });

        doc_correlati.DatiContratto.forEach((riga,i)=>{
            if((riga.CodiceCIG!="" || riga.CodiceCUP!="") && riga.IdDocumento=="")
                response.messages.push({type:"error", text: "ATTENZIONE, NON HAI SPECIFICATO L'ID Documento IN DOCUMENTI CORRELATI \
                                        NELLA VOCE 'Dati Contratto' alla linea N° "+ (i+1)+""});
                                        return response;

        });

        doc_correlati.DatiConvenzione.forEach((riga,i)=>{
            if((riga.CodiceCIG!="" || riga.CodiceCUP!="") && riga.IdDocumento=="")
                response.messages.push({type:"error", text: "ATTENZIONE, NON HAI SPECIFICATO L'ID Documento IN DOCUMENTI CORRELATI \
                                        NELLA VOCE 'Dati Convenzione' alla linea N° "+ (i+1)+""});
                                        return response;

        });

        doc_correlati.DatiRicezione.forEach((riga,i)=>{
            if((riga.CodiceCIG!="" || riga.CodiceCUP!="") && riga.IdDocumento=="")
                response.messages.push({type:"error", text: "ATTENZIONE, NON HAI SPECIFICATO L'ID Documento IN DOCUMENTI CORRELATI \
                                        NELLA VOCE 'Dati Ricezione' alla linea N° "+ (i+1)+""});
                                        return response;

        });

        doc_correlati.DatiFattureCollegate.forEach((riga,i)=>{
            if((riga.CodiceCIG!="" || riga.CodiceCUP!="") && riga.IdDocumento=="")
                response.messages.push({type:"error", text: "ATTENZIONE, NON HAI SPECIFICATO L'ID Documento IN DOCUMENTI CORRELATI \
                                        NELLA VOCE 'Dati Fatture Collegate' alla linea N° "+ (i+1)+""});
                                        return response;
        });

                //controllo se TD24 o TD25 allora deve esistere almeno un DDT...
                // commentato dopo mail di Paolo Ciano "analisi fattura agenti, nuovi bug ed implementazioni e riepilogo sospesi" del 02.04.2024
                /*if(this.fattura.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.TipoDocumento=='TD24' ||
                        this.fattura.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.TipoDocumento=='TD25'){
                        if( doc_correlati.DatiDDT.length==0){
                            response.messages.push({type:"error", text: "ATTENZIONE, PER TIPO DOCUMENTO TD24 O TD25 E' RICHIESTO ALMENO UN DDT ASSOCIATO"});
                            return response;
                        }
                        doc_correlati.DatiDDT.forEach((riga,i)=>{
                            if(riga.NumeroDDT=="" || riga.DataDDT=="")
                            response.messages.push({type:"error", text: "ATTENZIONE, NUMERO DDT E DATA DTT SONO OBBLIGATORI"});
                        });                           
                }*/
                

        /*****************************/


        return response;
    }

    public addUserDraft():ResponseConvalida{
        let response : ResponseConvalida = {messages: []};
        
        //controllo solo denominazione e partita iva.
        if(this.fattura.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.Anagrafica.PersonaFisica==1){
            if((this.fattura.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.Anagrafica.Nome=="") || 
                    (this.fattura.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.Anagrafica.Cognome=="")){
                    response.messages.push({type:"error", text: "ATTENZIONE, COMPILA NOME E COGNOME DEL CESSIONARIO/COMMITTENTE"});
                    return response;
                    }
        }else{
            if(this.fattura.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.Anagrafica.Denominazione==""){
                response.messages.push({type:"error", text: "ATTENZIONE, INSERISCI LA DENOMINAZIONE DEL CESSIONARIO/COMMITTENTE"});
                return response;
            }
        }
        /*if(this.fattura.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.IdFiscaleIVA.IdPaese.length!=2){
            response.messages.push({type:"error", text: "ATTENZIONE, NON HAI SPECIFICATO LA NAZIONALITA' DEL CESSIONARIO/COMMITTENTE"});
            return response;
        }

        if(this.fattura.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.IdFiscaleIVA.IdPaese ==""){
            response.messages.push({type:"error", text: "ATTENZIONE, INSERISCI LA PARTITA IVA DEL CESSIONARIO/COMMITTENTE"});
            return response;
        }*/
        
        if(this.fattura.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.Numero == ''){
            response.messages.push({type:"error", text: "SPECIFICA IL NUMERO DEL DOCUMENTO"});
            return response;
        }
        if(this.fattura.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.Data == ''){
            response.messages.push({type:"error", text: "SPECIFICA LA DATA DEL DOCUMENTO"});
            return response;
        }

        if(this.fattura.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.Causale?.filter(l => l == "").length > 0){
            response.messages.push({type:"error", text: "ATTENZIONE, LA VOCE CAUSALE DEI DATI DOCUMENTO CONTIENE UNA O PIU' RIGHE VUOTE. COMPILALE O ELIMINALE."});
            return response;
        }
        return response;
    }

    private controlloPartitaIVA(): boolean{
        var cessionario = this.fattura.FatturaElettronicaHeader.CessionarioCommittente;
        var nazioneCessionario = cessionario.DatiAnagrafici.IdFiscaleIVA.IdPaese;
        var partitaIVA = cessionario.DatiAnagrafici.IdFiscaleIVA.IdCodice;
        if (nazioneCessionario == "IT") {
            // la partita IVA non può essere minore di 11 caratteri
            if ((partitaIVA).length < 11) {
                return false;
            } else {
                return true;
            }
        } else {
            return true;
        }
    }

    //controllo codice fiscale
    //se azienda allora deve essere o vuoto o deve essere come PIVA
    // in caso di associazioni è solo numerico e non ha partita IVA
    private controlloFiscalCode(soggetto :any): boolean{
        var partitaIVA = soggetto.DatiAnagrafici.IdFiscaleIVA.IdCodice;
        var cf = soggetto.DatiAnagrafici.CodiceFiscale;
        var tipo = soggetto.DatiAnagrafici.Anagrafica.PersonaFisica;
        if(tipo == 0) {
            if (cf !== "") {
                if (!isNaN(cf)) {
                    // casistica di associazione, cf numerico e personaFisica NO
                    return true;
                } /*else {
                    return false;
                }*/
            }     
        } else {
            //tipo =1, persona fisica
            var paese=soggetto.DatiAnagrafici.IdFiscaleIVA.IdPaese;
            if(paese=="IT"){
                let re = new RegExp('^([A-Z]{6}[0-9LMNPQRSTUV]{2}[ABCDEHLMPRST]{1}[0-9LMNPQRSTUV]{2}[A-Z]{1}[0-9LMNPQRSTUV]{3}[A-Z]{1})$');
                return re.test(cf);
            }
            return true;
        }
        return true;
        
    }

       private controlloPartitaIvaOcodiceFiscaleRappFiscaleOSoggettoEmittente(data :any,type :string){
        var denominazione=data.DatiAnagrafici.Anagrafica.Denominazione;
        var nome=data.DatiAnagrafici.Anagrafica.Nome;
        var cognome=data.DatiAnagrafici.Anagrafica.Cognome;
        var nazione=data.DatiAnagrafici.IdFiscaleIVA.IdPaese;
        var partitaIVA=data.DatiAnagrafici.IdFiscaleIVA.IdCodice;
        var cf=data.DatiAnagrafici.CodiceFiscale;
        var eori=data.DatiAnagrafici.Anagrafica.CodEORI;

        var errors=[];
        var filled=[];
        if((nazione=="") && (partitaIVA=="") && (cf== "") && (eori=="") && (denominazione==""))
                return null;

        if(data.DatiAnagrafici!.Anagrafica.PersonaFisica == 0){
            if((nazione != "") && (partitaIVA !="") && (denominazione!=""))
                return null;
            else {
                    if(nazione=="")
                            errors.push("NAZIONE");
                    else    filled.push("NAZIONE");
                    if(partitaIVA=="")
                            errors.push("PARTITA IVA");
                    else    filled.push("PARTITA IVA");
                    if(denominazione=="")
                            errors.push("DENOMINAZIONE");
                    else    filled.push("DENOMINAZIONE");
                }
        }else{
            if((nazione != "") && (partitaIVA !="") && (nome!="") && (cognome!=""))
                return null;
                if(nazione=="")
                        errors.push("NAZIONE");
                else    filled.push("NAZIONE");
                if(partitaIVA=="")
                        errors.push("PARTITA IVA");
                else    filled.push("PARTITA IVA");
                if(nome=="")
                        errors.push("NOME");
                else    filled.push("NOME");
                if(cognome=="")
                        errors.push("COGNOME");
                else    filled.push("COGNOME");
            }
        if(errors.length==0)
            return null;
        return "ATTENZIONE inserisci: "+errors.join(', ')+" oppure pulisci i campi "+filled.join(', ')+' del '+type;
    }

    private controlloAnagrafica(anagrafica:any){
        //var denominazione=this.fattura.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.Anagrafica.Denominazione;
        var denominazione=anagrafica.Denominazione;
        if(denominazione==""){
            var nome=anagrafica.Nome;
            var cognome=anagrafica.Cognome;
            if((nome =="") || (cognome ==""))
                return false;
            return true;
        }
        return true;
    }

    private controlloSede(sede :any,type:string){
        //var sede=this.fattura.FatturaElettronicaHeader.CedentePrestatore.Sede;
        var indirizzo=sede.Indirizzo;
        var cap=sede.CAP;
        var comune=sede.Comune;
        var nazione=sede.Nazione;
        var provincia=sede.Provincia;
        let errors=[];
        if(indirizzo =="")
                errors.push('INDIRIZZO');
        if(cap =="")    
                errors.push('CAP');
        if(comune =="") 
                errors.push('CITTA\'');   
        if(nazione =="")   
                errors.push('NAZIONE'); 
        if(nazione == "IT")
            if(provincia =="")
                errors.push('PROVINCIA');
        if(errors.length==0)
                return null;
        return "ATTENZIONE inserisci: "+errors.join(', ')+" della SEDE del "+type;
    }
    
    private controlloStabileOrganizzazione(StabileOrganizzazione:any,type:string){
        var indirizzo=StabileOrganizzazione.Indirizzo;
        var cap=StabileOrganizzazione.CAP;
        var comune=StabileOrganizzazione.Comune;
        var provincia=StabileOrganizzazione.Provincia;
        var nazione=StabileOrganizzazione.Nazione;
        let errors=[];
        let filled=[];
        if((indirizzo=="") && (cap=="") && (comune=="") && (provincia=="") && (nazione==""))
                return null;
        if(indirizzo=="")
                errors.push('INDIRIZZO');
        else
                filled.push('INDIRIZZO');
        if(cap=="")
                errors.push('CAP');
        else
                filled.push('CAP');
        if(comune=="")
                errors.push('CITTA\'');
        else 
                filled.push('CITTA\'');
        if(nazione == "IT")
                if(provincia =="")
                        errors.push('PROVINCIA');
                else
                        filled.push('PROVINCIA');
        if(nazione=="")
                errors.push('NAZIONE');
        else filled.push('NAZIONE');

        if(errors.length==0)
                return null;
        return "ATTENZIONE inserisci: "+errors.join(', ')+" oppure pulisci i campi "+filled.join(', ')+' della STABILE ORGANIZZAZIONE del '+type;
    }


    private controlloIscrizioneReaCedentePrestatore(){
        var ufficio=this.fattura.FatturaElettronicaHeader.CedentePrestatore.IscrizioneREA.Ufficio;
        var numeroREA=this.fattura.FatturaElettronicaHeader.CedentePrestatore.IscrizioneREA.NumeroREA;
        var statoLiquidazione=this.fattura.FatturaElettronicaHeader.CedentePrestatore.IscrizioneREA.StatoLiquidazione;
        var errors=[];
        var filled=[];
        if((ufficio=="") && (numeroREA=="") && (statoLiquidazione==""))
                return null;
        if(ufficio=="")
                errors.push("UFFICIO");
        else    filled.push("UFFICIO");

        if(numeroREA=="")
                errors.push("NUMERO REA");
        else    filled.push("NUMERO REA");

        if(statoLiquidazione=="")
                errors.push("Stato Liquidazione");
        else    filled.push("Stato Liquidazione");

        if(errors.length==0)
            return null;
        return "ATTENZIONE inserisci "+errors.join(', ')+" oppure pulisci i campi "+filled.join(', ')+' dei dati di ISCRIZIONE REA del CEDENTE/PRESTATORE';
    }



    private controllo00415(): boolean{
        var dgd = this.fattura.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento;
        if ((dgd.DatiCassaPrevidenziale).length > 0) {
            for (var i = 0; i < dgd.DatiCassaPrevidenziale.length; i++) {
                if (dgd.DatiCassaPrevidenziale[i].Ritenuta == "SI") {
                    if ((dgd.DatiRitenuta).length == 0) {
                        return false;
                    }
                }
            }
        }
        var dg = this.fattura.FatturaElettronicaBody.DatiBeniServizi;
        for (var i = 0; i < dg.DettaglioLinee.length; i++) {
            if ((dg.DettaglioLinee[i].Ritenuta) == "SI") {
                if ((dgd.DatiRitenuta).length == 0) {
                    return false;
                }
            }
        }
        return true;
    }

    private controllo00471(): boolean{
        const arrayTipi = ['TD01', 'TD02', 'TD03', 'TD06', 'TD07', 'TD16', 'TD17', 'TD18', 'TD19', 'TD20', 'TD24', 'TD245', 'TD28', 'TD29'];
        if (arrayTipi.includes(this.fattura.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.TipoDocumento))
        /*if (this.fattura.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.TipoDocumento == 'TD16' ||
            this.fattura.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.TipoDocumento == 'TD17' ||
            this.fattura.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.TipoDocumento == 'TD18' ||
            this.fattura.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.TipoDocumento == 'TD19' ||
            this.fattura.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.TipoDocumento == 'TD20')*/ {
            // in questo caso il cedente non può essere uguale al cessionario
            var cedente = this.fattura.FatturaElettronicaHeader.CedentePrestatore;
            var cessionario = this.fattura.FatturaElettronicaHeader.CessionarioCommittente;
            var datiFiscaliCedente = cedente.DatiAnagrafici.IdFiscaleIVA.IdCodice;
            var datiFiscaliCessionario = cessionario.DatiAnagrafici.IdFiscaleIVA.IdCodice;

            if (datiFiscaliCedente == "" || datiFiscaliCessionario == "") {
                datiFiscaliCedente = cedente.DatiAnagrafici.CodiceFiscale;
                datiFiscaliCessionario = cessionario.DatiAnagrafici.CodiceFiscale;
            }
            if (datiFiscaliCedente == datiFiscaliCessionario) {
                return false;
            }
        }
        return true;
    }

    private controllo00472():boolean{
        if (this.fattura.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.TipoDocumento == 'TD21' ||
            this.fattura.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.TipoDocumento == 'TD27') {
            // in questo caso il cedente DEVE essere uguale al cessionario
            var cedente = this.fattura.FatturaElettronicaHeader.CedentePrestatore;
            var cessionario = this.fattura.FatturaElettronicaHeader.CessionarioCommittente;
            var datiFiscaliCedente = cedente.DatiAnagrafici.IdFiscaleIVA.IdCodice;
            var datiFiscaliCessionario = cessionario.DatiAnagrafici.IdFiscaleIVA.IdCodice;

            if (datiFiscaliCedente == "" || datiFiscaliCessionario == "") {
                datiFiscaliCedente = cedente.DatiAnagrafici.CodiceFiscale;
                datiFiscaliCessionario = cessionario.DatiAnagrafici.CodiceFiscale;
            }
            if (datiFiscaliCedente == datiFiscaliCessionario) {
                return true;
            } else {
                return false;
            }
        }
        return true;
    }

    private controllo00473(): boolean{
        if (this.fattura.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.TipoDocumento == 'TD17' ||
            this.fattura.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.TipoDocumento == 'TD18' ||
            this.fattura.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.TipoDocumento == 'TD19' ||
            this.fattura.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.TipoDocumento == 'TD28') {
            // in questo caso il cedente non può essere uguale italiano
            var cedente = this.fattura.FatturaElettronicaHeader.CedentePrestatore;
            var nazioneCedente = cedente.DatiAnagrafici.IdFiscaleIVA.IdPaese;

            if (nazioneCedente == "") {
                nazioneCedente = cedente.Sede.Nazione;
            }
            if (nazioneCedente == "IT") {
                return false;
            }
        }
        return true;
    }

    private controllo00474(): boolean{
        if (this.fattura.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.TipoDocumento == 'TD21') {
            // in questo caso il cedente DEVE essere uguale al cessionario
            var dettaglioLinee = this.fattura.FatturaElettronicaBody.DatiBeniServizi.DettaglioLinee;
            for (var i = 0; i < dettaglioLinee.length; i++) {
                if (dettaglioLinee[i].AliquotaIVA == '0.00') {
                    return false;
                }
            }
        }
        return true;
    }

    private controlloDocumentiCorrelati(): boolean{
        var dg = this.fattura.FatturaElettronicaBody.DatiGenerali;
        if (dg.DatiOrdineAcquisto.length > 0) {
            for (var i = 0; i < dg.DatiOrdineAcquisto.length; i++) {
                if (dg.DatiOrdineAcquisto[i].CodiceCIG != "" || dg.DatiOrdineAcquisto[i].CodiceCUP != "") {
                    if (dg.DatiOrdineAcquisto[i].IdDocumento == "") {
                        return false;
                    }
                }
            }
        }
        if (dg.DatiContratto.length > 0) {
            for (var i = 0; i < dg.DatiContratto.length; i++) {
                if (dg.DatiContratto[i].CodiceCIG != "" || dg.DatiContratto[i].CodiceCUP != "") {
                    if (dg.DatiContratto[i].IdDocumento == "") {
                        return false;
                    }
                }
            }
        }
        if (dg.DatiConvenzione.length > 0) {
            for (var i = 0; i < dg.DatiConvenzione.length; i++) {
                if (dg.DatiConvenzione[i].CodiceCIG != "" || dg.DatiConvenzione[i].CodiceCUP != "") {
                    if (dg.DatiConvenzione[i].IdDocumento == "") {
                        return false;
                    }
                }
            }
        }
        if (dg.DatiRicezione.length > 0) {
            for (var i = 0; i < dg.DatiRicezione.length; i++) {
                if (dg.DatiRicezione[i].CodiceCIG != "" || dg.DatiRicezione[i].CodiceCUP != "") {
                    if (dg.DatiRicezione[i].IdDocumento == "") {
                        return false;
                    }
                }
            }
        }
        if (dg.DatiFattureCollegate.length > 0) {
            for (var i = 0; i < dg.DatiFattureCollegate.length; i++) {
                if (dg.DatiFattureCollegate[i].CodiceCIG != "" || dg.DatiFattureCollegate[i].CodiceCUP != "") {
                    if (dg.DatiFattureCollegate[i].IdDocumento == "") {
                        return false;
                    }
                }
            }
        }

        return true;
    }
}